import { render, staticRenderFns } from "./StaffDailyRosterImport.vue?vue&type=template&id=f23b3382"
import script from "./StaffDailyRosterImport.vue?vue&type=script&lang=js"
export * from "./StaffDailyRosterImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports